import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26153da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "popup-feedback",
  id: "feedback-modal"
}
const _hoisted_2 = { class: "popup-feedback-fixed" }
const _hoisted_3 = { class: "popup-body-fb" }
const _hoisted_4 = { class: "popup-contain" }
const _hoisted_5 = { class: "visible-pc" }
const _hoisted_6 = {
  id: "msform",
  onsubmit: "return false"
}
const _hoisted_7 = { style: {"display":"block"} }
const _hoisted_8 = {
  class: "popup-title-w-back height-title popup-font-tiempos",
  id: "title-head"
}
const _hoisted_9 = ["textContent"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-hc-2x zmdi-close" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "contain",
  id: "step-form-1"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro" }, "Bạn có sẵn sàng giới thiệu Rever cho người khác?", -1))
const _hoisted_14 = { class: "choose-number" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "emotion" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["textContent"]
const _hoisted_20 = {
  class: "contain",
  id: "step-form-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro" }, "Bạn có thấy Rever.vn dễ sử dụng không?", -1))
const _hoisted_22 = { class: "row row-fb pd-t-39 pd-bt-68 center-item" }
const _hoisted_23 = { class: "contain" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro" }, "Bạn muốn Rever.vn cần cải thiện thêm về điều gì?", -1))
const _hoisted_25 = { class: "checkbox-option" }
const _hoisted_26 = { class: "checkbox-pc" }
const _hoisted_27 = { class: "row-fb" }
const _hoisted_28 = { class: "container-cb" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_30 = { class: "container-cb" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_32 = { class: "container-cb" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_34 = { class: "container-cb" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_36 = { class: "share-rv" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"initial"} }, "Ý kiến khác", -1))
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "send" }
const _hoisted_41 = { class: "visible-sm" }
const _hoisted_42 = { class: "header-sm" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-hc-2x zmdi-close" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Phản hồi của bạn về Rever.vn", -1))
const _hoisted_46 = { class: "content" }
const _hoisted_47 = { class: "intro-sm" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bạn có sẵn sàng giới thiệu Rever cho người khác?", -1))
const _hoisted_49 = { class: "choose-number" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["textContent"]
const _hoisted_52 = { class: "use-easy" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bạn thấy Rever có dễ sử dụng không?", -1))
const _hoisted_54 = { class: "row pt-15 center-item" }
const _hoisted_55 = { class: "improve" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bạn muốn Rever.vn cần cải thiện thêm về điều gì?", -1))
const _hoisted_57 = { class: "checkbox-sm" }
const _hoisted_58 = { class: "container-cb" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_60 = { class: "container-cb" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_62 = { class: "container-cb" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_64 = { class: "container-cb" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_66 = { class: "note" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ý kiến khác", -1))
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "btn" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { class: "popup-fb-success" }
const _hoisted_72 = { class: "popup-header" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "popup-title-w-back height-title popup-font-tiempos" }, "Phản hồi của bạn về Rever.vn", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-hc-2x zmdi-close" }, null, -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "popup-contain" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-success",
  src: "/images/icon-success.svg"
}, null, -1))
const _hoisted_78 = { class: "send-success" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Đã gửi thành công!", -1))
const _hoisted_80 = { class: "popup-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("fieldset", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, [
                  _createTextVNode("Phản hồi của bạn về Rever.vn ("),
                  _createElementVNode("span", {
                    textContent: _toDisplayString(_ctx.step)
                  }, null, 8, _hoisted_9),
                  _createTextVNode("/3)")
                ]),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideModal())),
                  class: "popup-close-btn"
                }, _hoisted_11),
                _withDirectives(_createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingPoints, (i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          onClick: ($event: any) => (_ctx.selectStep1Rate(i))
                        }, [
                          _createElementVNode("a", {
                            class: _normalizeClass({active: _ctx.step1.rate == i}),
                            href: "javascript:void(0)",
                            textContent: _toDisplayString(i)
                          }, null, 10, _hoisted_16)
                        ], 8, _hoisted_15))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: '/images/' + _ctx.step1Icon,
                      alt: ""
                    }, null, 8, _hoisted_18),
                    _createElementVNode("p", {
                      textContent: _toDisplayString(_ctx.step1Msg),
                      style: {"display":"block"}
                    }, null, 8, _hoisted_19)
                  ])
                ], 512), [
                  [_vShow, _ctx.step == 1]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: _normalizeClass([{active : _ctx.step2.rate === _ctx.UX.HARD}, "large-butt-grey btn-use mgr-r-20"]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectStep2Rate(_ctx.UX.HARD)))
                    }, "Khó sử dụng", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass([{active : _ctx.step2.rate === _ctx.UX.NORMAL}, "large-butt-grey btn-use pd-use-btn mgr-r-20"]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectStep2Rate(_ctx.UX.NORMAL)))
                    }, "Bình thường", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass([{active : _ctx.step2.rate === _ctx.UX.EASY}, "large-butt-grey btn-use"]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectStep2Rate(_ctx.UX.EASY)))
                    }, "Dễ sử dụng", 2)
                  ])
                ], 512), [
                  [_vShow, _ctx.step == 2]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_28, [
                            _createTextVNode("Giao diện đẹp hơn "),
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step3.improve.ui) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.step3.improve.ui]
                            ]),
                            _hoisted_29
                          ]),
                          _createElementVNode("label", _hoisted_30, [
                            _createTextVNode("Nội dung chính xác hơn "),
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step3.improve.content) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.step3.improve.content]
                            ]),
                            _hoisted_31
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_32, [
                            _createTextVNode("Thêm tính năng "),
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step3.improve.feature) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.step3.improve.feature]
                            ]),
                            _hoisted_33
                          ]),
                          _createElementVNode("label", _hoisted_34, [
                            _createTextVNode("Khác (vui lòng nhập) "),
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step3.improve.other) = $event)),
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSelectOtherMsg('')))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.step3.improve.other]
                            ]),
                            _hoisted_35
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step3.otherMsg) = $event)),
                        placeholder: "Nhập ý kiến khác",
                        ref: "msg",
                        disabled: !_ctx.step3.improve.other
                      }, null, 8, _hoisted_38), [
                        [_vModelText, _ctx.step3.otherMsg]
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.step == 3]
                ]),
                _withDirectives(_createElementVNode("a", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.gotoStep(_ctx.step - 1))),
                  class: "butt-primary butt-transparent prev",
                  href: "javascript:void(0)",
                  id: "prev"
                }, "Trước", 512), [
                  [_vShow, _ctx.step > 1]
                ]),
                _withDirectives(_createElementVNode("a", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onClickNext())),
                  disabled: !_ctx.canNext,
                  class: "butt-primary btn-grey next",
                  href: "javascript:void(0)",
                  id: "next"
                }, "Tiếp", 8, _hoisted_39), [
                  [_vShow, _ctx.step < 3]
                ]),
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onClickSend && _ctx.onClickSend(...args))),
                  class: "butt-primary btn-grey"
                }, [
                  _withDirectives(_createElementVNode("span", _hoisted_40, "Gửi", 512), [
                    [_vShow, !_ctx.isSending]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "Đang gửi...", 512), [
                    [_vShow, _ctx.isSending]
                  ])
                ], 512), [
                  [_vShow, _ctx.step == 3]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.hideModal())),
                class: "popup-close-btn-sm"
              }, _hoisted_44),
              _hoisted_45
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingPoints, (i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        onClick: ($event: any) => (_ctx.selectStep1Rate(i))
                      }, [
                        _createElementVNode("a", {
                          class: _normalizeClass({active: _ctx.step1.rate == i}),
                          href: "javascript:void(0)",
                          textContent: _toDisplayString(i)
                        }, null, 10, _hoisted_51)
                      ], 8, _hoisted_50))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{active : _ctx.step2.rate == 'hard'}, "large-butt-grey btn-use mgr-r-20"]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectStep2Rate('hard')))
                  }, "Khó sử dụng", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass([{active : _ctx.step2.rate == 'normal'}, "large-butt-grey btn-use pd-use-btn"]),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectStep2Rate('normal')))
                  }, "Bình thường", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass([{active : _ctx.step2.rate == 'easy'}, "large-butt-grey btn-use"]),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectStep2Rate('easy')))
                  }, "Dễ sử dụng", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, [
                    _createTextVNode("Giao diện đẹp hơn "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.step3.improve.ui) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.step3.improve.ui]
                    ]),
                    _hoisted_59
                  ]),
                  _createElementVNode("label", _hoisted_60, [
                    _createTextVNode("Nội dung chính xác hơn "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.step3.improve.content) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.step3.improve.content]
                    ]),
                    _hoisted_61
                  ]),
                  _createElementVNode("label", _hoisted_62, [
                    _createTextVNode("Thêm tính năng "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.step3.improve.feature) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.step3.improve.feature]
                    ]),
                    _hoisted_63
                  ]),
                  _createElementVNode("label", _hoisted_64, [
                    _createTextVNode("Khác (vui lòng nhập) "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.step3.improve.other) = $event)),
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onSelectOtherMsg('2')))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.step3.improve.other]
                    ]),
                    _hoisted_65
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.step3.otherMsg) = $event)),
                  placeholder: "Nhập ý kiến khác",
                  ref: "msg2",
                  disabled: !_ctx.step3.improve.other
                }, null, 8, _hoisted_68), [
                  [_vModelText, _ctx.step3.otherMsg]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("button", {
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onClickSend && _ctx.onClickSend(...args))),
                disabled: !_ctx.canSubmit,
                class: "butt-primary btn-red"
              }, "Gửi phản hồi", 8, _hoisted_70)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.state == 'composing']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("button", {
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.hideModal())),
              class: "popup-close-btn"
            }, _hoisted_75)
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("p", null, [
                _createTextVNode("Cảm ơn bạn đã gửi phản hồi cho Rever, ý kiến của bạn sẽ giúp Rever.vn từng bước nâng cao chất lượng sản phẩm. Mọi thắc mắc nếu có xin vui lòng liên hệ hotline (24/7): "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.hotline), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("a", {
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.hideModal())),
              class: "butt-primary butt-red btn-red",
              href: "javascript:void(0)"
            }, "Đóng")
          ])
        ], 512), [
          [_vShow, _ctx.state == 'finished']
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.isShowModal]
  ])
}